export default "assets/cn-9f7f4123.svg";